import { useEffect, useState } from 'react';
import { Card, Grid, Space, Tabs, Typography, Alert, message } from 'antd';
import Profile from '../components/ProfileTabComponents/Profile';
import Application from '../components/ProfileTabComponents/PersonalDetails';
import Refer from '../components/ProfileTabComponents/Refer';
import AccountSettings from '../components/ProfileTabComponents/AccountSettings';
import styles from '../styles/Tabs.module.scss';
import { storageUtil } from '@/utils/storageUtil';
import BillingAndPayments from '../components/ProfileTabComponents/BillingAndPayments';
import { useDeleteUserMutation } from '../api/profileAPI';
import { useAppDispatch, useAppSelector } from '@/hooks/hooks';
import { clearAuthToken } from '@/store/slices/auth/authSlice';
import ContainerWrapper from '@/pages/layout/ContainerWrapper';
import ShareAccount from '../components/ProfileTabComponents/ShareAccount';
import HouseholdExpenditure from '../components/ProfileTabComponents/HouseholdExpenditure';
import { useFetchUserDataQuery } from '@/store/apis/userApi';

export const ProfilePage = () => {
  const { data: profileData, refetch } = useFetchUserDataQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  const LOCAL_STORAGE_KEY = 'activeProfileTab';

  // '3' was the "Password & Security" tab, removed with client passwords.
  const getInitialActiveTab = () => {
    const saved = storageUtil.getItem<string>(LOCAL_STORAGE_KEY);
    return saved && saved !== '3' ? saved : '1';
  };

  const [activeKey, setActiveKey] = useState<string>(getInitialActiveTab());

  const handleTabChange = (key: string) => {
    setActiveKey(key);
    storageUtil.setItem(LOCAL_STORAGE_KEY, key);
  };

  const [deleteUser, { isLoading }] = useDeleteUserMutation();

  const [emailVerified, setEmailVerified] = useState(true);

  console.log('profileData', profileData?.data);

  useEffect(() => {
    if (profileData?.data?.isEmailVerified !== undefined) {
      setEmailVerified(profileData.data.isEmailVerified);
    }
  }, [profileData]);

  const { useBreakpoint } = Grid;

  const { xs, lg } = useBreakpoint();

  return (
    <ContainerWrapper>
      <div>
        {!emailVerified && (
          <Alert
            banner
            message={
              <Space
                direction={xs ? 'vertical' : 'horizontal'}
                wrap
                style={{
                  width: '100%',
                  justifyContent: xs ? 'start' : 'space-between',
                  rowGap: 8,
                }}
              >
                <Typography.Text
                  style={{
                    fontSize: xs ? 13 : 15,
                    textAlign: xs ? 'left' : 'inherit',
                    lineHeight: 1.4,
                  }}
                >
                  {xs
                    ? 'Sign in with your email to verify it and unlock all features.'
                    : 'Sign in with your email address to verify it. Some features may be limited until your email is verified.'}
                </Typography.Text>
              </Space>
            }
            type="warning"
            showIcon
            style={{
              marginTop: '0.5rem',
              padding: xs ? '5px 7px' : '8px 12px',
            }}
          />
        )}
        <Card
          title={
            <Typography.Title
              level={4}
              style={{
                margin: 0,
              }}
            >
              Profile Settings
            </Typography.Title>
          }
          style={{
            width: '100%',
            marginTop: '0.5rem',
          }}
        >
          <div
            style={{
              width: '100%',
              paddingRight: '2rem',
              height: '100%',
              margin: '20px',
            }}
          >
            <Tabs
              className={styles.tabs}
              activeKey={activeKey}
              onChange={handleTabChange}
              tabPosition={lg ? 'left' : 'top'}
              title="Profile Settings"
              tabBarStyle={{
                width: '100%',
                maxWidth: lg ? '250px' : '100%',
              }}
              tabBarExtraContent={{}}
              items={[
                {
                  key: '1',
                  label: (
                    <Typography.Text
                      style={{
                        margin: '0',
                        fontSize: '1.05rem',
                      }}
                    >
                      My Profile
                    </Typography.Text>
                  ),
                  children: <Profile />,
                },
                {
                  key: '2',
                  label: (
                    <Typography.Text
                      style={{
                        margin: '0',
                        fontSize: '1.05rem',
                      }}
                    >
                      Personal Details
                    </Typography.Text>
                  ),
                  children: <Application />,
                },
                {
                  key: '8',
                  label: (
                    <Typography.Text
                      style={{
                        margin: '0',
                        fontSize: '1.05rem',
                      }}
                    >
                      Household Expenditure
                    </Typography.Text>
                  ),
                  children: <HouseholdExpenditure />,
                },
                // {
                //   key: '4',
                //   label: (
                //     <Typography.Text
                //       style={{
                //         margin: '0',
                //         fontSize: '1.05rem',
                //       }}
                //     >
                //       Refer & Earn
                //     </Typography.Text>
                //   ),

                //   children: <Refer />,
                // },
                // {
                //   key: '5',
                //   label: (
                //     <Typography.Text
                //       style={{
                //         margin: '0',
                //         fontSize: '1.05rem',
                //       }}
                //     >
                //       Billing & Payments
                //     </Typography.Text>
                //   ),
                //   children: <BillingAndPayments />,
                // },
                // {
                //   key: '7',
                //   label: (
                //     <Typography.Text
                //       style={{
                //         margin: '0',
                //         fontSize: '1.05rem',
                //       }}
                //     >
                //       Share Account
                //     </Typography.Text>
                //   ),
                //   children: <ShareAccount />,
                // },
                // {
                //   key: '6',
                //   label: (
                //     <Typography.Text
                //       style={{
                //         margin: '0',
                //         fontSize: '1.05rem',
                //       }}
                //     >
                //       Account Settings
                //     </Typography.Text>
                //   ),
                //   children: <AccountSettings />,
                // },
              ]}
            />
          </div>
        </Card>
      </div>
    </ContainerWrapper>
  );
};
